import './App.css';
import Search from './components/Search.js';
import Title from './components/Title';

function App() {
  return (
    <div className='app'>
      <Title />

      <Search />
    </div>
  );
}

export default App;
